<template>
  <div class="list-item">
    <div
      v-for="(item, index) in data"
      :key="index"
      class="item"
      @click="jumpDetail(item)"
    >
      <div class="content">
        <span v-if="data && data.length > 0" class="dot" />
        <span class="title">{{ item.title }}</span>
      </div>
      <span v-if="isShowTime" class="date">{{ item.published_time | tems }}</span>
    </div>
   
  </div>
</template>
  
  <script>
export default {
  props: {
    isShowTime: {
      type: Boolean,
      default: true,
    },
    type: {
      type: Number,
      default: 1,
    },
    data: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {};
  },
  filters:{
    tems(i){
      if (i) {
        return i.slice(5)
      }else{
        return ''
      }
    },
  },
  methods: {
    jumpMore() {
      if (this.type === 1) {
        this.$router.push({
          path: "/newsList",
          query: {
            categoryId: 50201,
            title:'时政要闻'
          },
        });
      } else if (this.type === 2) {
        this.$router.push({
          path: "/newsList",
          query: {
            categoryId: 50202,
            title:'全总新闻'
          },
        });
      } else if (this.type === 3) {
        this.$router.push({
          path: "/newsList",
          query: {
            categoryId: 50203,
            title:'省总新闻'
          },
        });
      }
    },
    /**
     * 跳转到详情页
     * @param {Object} item - 新闻项对象
     * info_type: 0-图文, 1-视频, 2-音频, 3-跳转, 4-文件, 5-附件
     */
    jumpDetail(item) {
      if (
        item.info_type === 0 ||
        item.info_type === 1 ||
        item.info_type === 2 ||
        item.info_type === 4
      ) {
        // 图文、视频、音频、文件类型，跳转到详情页
        this.$router.push({
          path: "/detail",
          query: {
            newsId: item.id,
          },
        });
      } else if (item.info_type === 3) {
        // 跳转类型，打开外部链接
        window.open(item.jump_url);
      } else if (item.info_type === 5) {
        // 附件类型，打开附件
        window.open(item.attachment);
      }
    },
  },
};
</script>
  
<style lang="scss" scoped>
.list-item {
  width: 98%;
  margin: 0 auto;
  height: auto;

  .item {
    font-size: 28px;
    font-family: Source Han Sans SC VF, Source Han Sans SC VF;
    font-weight: 500;
    color: #333333;
    line-height: 40px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    cursor: pointer;
    padding: 20px 12px;
    border-bottom: 1px solid #f0f0f0;

    &:last-child {
      border-bottom: none;
    }

    &:active {
      background-color: #f5f5f5;
    }

    &:hover {
      color: #b8190a;
      font-weight: 600;
    }

    .content {
      display: flex;
      align-items: center;
      overflow: hidden;
    }

    .dot {
      width: 10px;
      height: 10px;
      background-color: #c18c8d;
      border-radius: 50%;
      margin-right: 10px;
      flex-shrink: 0;
    }

    .title {
      flex: 1;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    .date {
      font-size: 25px;
      font-family: Source Han Sans SC VF, Source Han Sans SC VF;
      font-weight: 400;
      color: #999999;
      white-space: nowrap;
      margin-left: 16px;
    }
  }

  .more {
    font-weight: 500;
    font-size: 24px;
    color: #000000;
    line-height: 42px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    img {
      width: 28px;
      height: 15px;
      margin-left: 15px;
    }
  }
}
</style>
  